if (!customElements.get('collection-quick-order')) {
  customElements.define(
    'collection-quick-order',
    class CollectionQuickOrder extends HTMLElement {
      connectedCallback() {
        if (this.initialized) return;
        this.initialized = true;

        this.select = this.querySelector('[data-variant-select]');
        this.variantInput = this.querySelector('[data-variant-input]');
        this.price = this.querySelector('[data-variant-price]');
        this.quantityInput = this.querySelector('[data-quantity-input]');
        this.submitButton = this.querySelector('[data-submit-button]');
        this.submitLabel = this.querySelector('[data-submit-label]');

        this.addEventListener('click', (event) => event.stopPropagation());
        this.addEventListener('pointerdown', (event) => event.stopPropagation());

        this.select?.addEventListener('change', () => this.updateVariant());

        this.querySelectorAll('[data-quantity-change]').forEach((button) => {
          button.addEventListener('click', (event) => {
            event.preventDefault();
            event.stopPropagation();
            this.changeQuantity(Number(button.dataset.quantityChange));
          });
        });

        this.quantityInput?.addEventListener('change', () => this.normalizeQuantity());
        this.updateVariant();
      }

      updateVariant() {
        const option = this.select?.selectedOptions?.[0];
        if (!option) {
          this.normalizeQuantity();
          return;
        }

        const available = option.dataset.available === 'true';
        this.variantInput.value = option.value;
        this.variantInput.disabled = !available;
        this.price.textContent = option.dataset.price || '';

        this.quantityInput.min = option.dataset.min || '1';
        this.quantityInput.step = '1';
        if (option.dataset.max) this.quantityInput.max = option.dataset.max;
        else this.quantityInput.removeAttribute('max');

        this.submitButton.disabled = !available;
        this.submitLabel.textContent = available ? this.dataset.addLabel : this.dataset.soldOutLabel;
        this.normalizeQuantity();
      }

      changeQuantity(change) {
        const current = Number.parseInt(this.quantityInput.value, 10) || 1;
        this.quantityInput.value = current + change;
        this.normalizeQuantity();
        this.quantityInput.dispatchEvent(new Event('change', { bubbles: true }));
      }

      normalizeQuantity() {
        const min = Number.parseInt(this.quantityInput.min, 10) || 1;
        const max = Number.parseInt(this.quantityInput.max, 10);
        let value = Number.parseInt(this.quantityInput.value, 10);

        if (!Number.isFinite(value)) value = min;
        value = Math.max(min, value);
        if (Number.isFinite(max)) value = Math.min(max, value);

        this.quantityInput.value = value;
      }
    }
  );
}
